// Lightweight access to the logged-in user's role names.
//
// The login and signup responses reliably include the user's full role set, so we
// stash the role names in localStorage as the session is established. This is more
// dependable than the profile endpoint (whose roles are lazy-loaded and can come
// back empty). userLogout() runs localStorage.clear(), so this is cleared
// automatically on logout.

const ROLES_KEY = "ftUserRoles";

export const ROLE_REFERRAL_PARTNER = "ReferralPartner";
export const ROLE_CLIENT = "User";

/** Persist role names from a login or signup response, e.g. [{name:"User"}, ...]. */
export function persistUserRoles(roles) {
  try {
    const names = (roles || []).map((r) => r?.name).filter(Boolean);
    localStorage.setItem(ROLES_KEY, JSON.stringify(names));
  } catch {
    /* localStorage unavailable — toggles just won't show */
  }
}

/**
 * Forget the stored roles. Call this when a session ends without a full logout —
 * staff reverting from an impersonated account back to their own. The roles
 * describe whoever is signed in now, so leaving the impersonated user's behind
 * would have the app treat staff as that user.
 */
export function clearUserRoles() {
  try {
    localStorage.removeItem(ROLES_KEY);
  } catch {
    /* localStorage unavailable — nothing was stored to clear */
  }
}

/** Current user's role names (empty array if none stored). */
export function getUserRoleNames() {
  try {
    const raw = localStorage.getItem(ROLES_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function hasRole(name) {
  return getUserRoleNames().includes(name);
}
